import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import alertify from 'alertifyjs/build/alertify.min.js';
import 'alertifyjs/build/css/alertify.min.css';
import 'alertifyjs/build/css/themes/default.min.css';
import VeeValidate from 'vee-validate';
import VueGtag from "vue-gtag";

window.alertify = alertify;

alertify.set('notifier', 'delay', 5);
alertify.set('notifier', 'position', 'top-center');
alertify.set('prompt', 'reverseButtons', true);
alertify.set('prompt', 'transition', 'fade');
alertify.set('confirm', 'transition', 'fade');

Vue.config.productionTip = false;

Vue.use(VeeValidate, {
	events: 'blur',
	classes: true
});

Vue.use(VueGtag, {
  config: { id: "UA-156971159-2" }
});

new Vue({
	router,
	store,
	render: (h) => h(App)
}).$mount('#app');
